import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "ep-drawer-h" }
const _hoisted_3 = { class: "ep-drawer-b" }
const _hoisted_4 = ["value", "placeholder"]
const _hoisted_5 = { class: "ep-chips on-drawer" }
const _hoisted_6 = ["aria-pressed", "onClick"]
const _hoisted_7 = { class: "ep-chips on-drawer" }
const _hoisted_8 = ["aria-pressed", "onClick"]
const _hoisted_9 = { class: "ep-chips on-drawer" }
const _hoisted_10 = ["aria-pressed", "onClick"]
const _hoisted_11 = { class: "ep-drawer-f" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_process_owner_picker = _resolveComponent("process-owner-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "ep-scrim",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }),
    _createElementVNode("aside", {
      class: "ep-drawer",
      role: "dialog",
      "aria-label": _ctx.typeLabel + ' details'
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Details", -1)),
        _createElementVNode("button", {
          type: "button",
          "aria-label": "Close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
            _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("label", {
          class: "ep-lbl",
          for: "ep-name"
        }, "Name", -1)),
        _createElementVNode("input", {
          id: "ep-name",
          value: _ctx.name,
          type: "text",
          class: "ep-name",
          placeholder: 'Name of this ' + _ctx.typeLabel,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:name', ($event.target as HTMLInputElement).value)))
        }, null, 40, _hoisted_4),
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "ep-lbl" }, "Owners", -1)),
        _createVNode(_component_process_owner_picker, {
          "model-value": _ctx.ownerIds,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:ownerIds', $event)))
        }, null, 8, ["model-value"]),
        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "ep-lbl" }, "Locations", -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationOptions, (loc) => {
            return (_openBlock(), _createElementBlock("button", {
              key: loc,
              type: "button",
              class: _normalizeClass(['ep-chip', { on: _ctx.locs.includes(loc) }]),
              "aria-pressed": _ctx.locs.includes(loc),
              onClick: ($event: any) => (_ctx.$emit('update:locs', _ctx.toggled(_ctx.locs, loc)))
            }, _toDisplayString(loc), 11, _hoisted_6))
          }), 128))
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "ep-lbl" }, "Departments", -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departmentOptions, (dep) => {
            return (_openBlock(), _createElementBlock("button", {
              key: dep,
              type: "button",
              class: _normalizeClass(['ep-chip', { on: _ctx.deps.includes(dep) }]),
              "aria-pressed": _ctx.deps.includes(dep),
              onClick: ($event: any) => (_ctx.$emit('update:deps', _ctx.toggled(_ctx.deps, dep)))
            }, _toDisplayString(dep), 11, _hoisted_8))
          }), 128))
        ]),
        (_ctx.typeOptions.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "ep-lbl" }, "Types", -1)),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (type) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: type,
                    type: "button",
                    class: _normalizeClass(['ep-chip', { on: _ctx.types.includes(type) }]),
                    "aria-pressed": _ctx.types.includes(type),
                    onClick: ($event: any) => (_ctx.$emit('update:types', _ctx.toggled(_ctx.types, type)))
                  }, _toDisplayString(type), 11, _hoisted_10))
                }), 128))
              ])
            ], 64))
          : _createCommentVNode("", true),
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "ep-muted" }, "These show at the top right of the document.", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, "Done")
      ])
    ], 8, _hoisted_1)
  ], 64))
}